import React, { useEffect, useRef, useState } from "react";

const API = "https://live-evo.com/api";
const BASE_URL = "https://live-evo.com";
const NEON = "#00f2ff";

function musicCoverUrl(path) {
  const value = String(path || "").trim();

  if (!value) return "";

  if (/^https?:\/\//i.test(value)) {
    return value;
  }

  return `${BASE_URL}/${value.replace(/^\/+/, "")}`;
}

function AdminMusicWebPage() {
  const audioRef = useRef(null);

  const [musics, setMusics] = useState([]);
  const [loading, setLoading] = useState(true);

  const [selectedMusic, setSelectedMusic] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);

  const [removeConfirm, setRemoveConfirm] = useState(false);
  const [removeError, setRemoveError] = useState("");
  const [removing, setRemoving] = useState(false);

  const [current, setCurrent] = useState(null);
  const [playing, setPlaying] = useState(false);

  const [position, setPosition] = useState(0);
  const [duration, setDuration] = useState(0);

  useEffect(() => {
    loadMusic();
  }, []);

  const loadMusic = async () => {
    try {
      const res = await fetch(`${API}/music/catalog`);
      const data = await res.json();

      setMusics(Array.isArray(data) ? data : []);
    } catch {
      alert("Impossible de charger musiques");
    } finally {
      setLoading(false);
    }
  };

  const playMusic = (item) => {
    const url = encodeURI(
      `${BASE_URL}/${item.file_path}`
    );

    if (audioRef.current) {
      audioRef.current.pause();
    }

    const audio = new Audio(url);

    audioRef.current = audio;

    audio.onloadedmetadata = () => {
      setDuration(audio.duration || 0);
    };

    audio.ontimeupdate = () => {
      setPosition(audio.currentTime || 0);
    };

    audio.onended = () => {
      setPlaying(false);
    };

    audio.play();

    setCurrent(item);
    setPlaying(true);
  };

  const togglePlay = () => {
    if (!audioRef.current) return;

    if (playing) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }

    setPlaying(!playing);
  };

  const seek = (e) => {
    const value = Number(e.target.value);

    if (!audioRef.current) return;

    audioRef.current.currentTime = value;
    setPosition(value);
  };

  const format = (s) => {
    const m = Math.floor(s / 60);
    const sec = Math.floor(s % 60);

    return `${m}:${sec < 10 ? "0" : ""}${sec}`;
  };

  const save = async () => {
    try {
      await fetch(
        `${API}/music/catalog/${selectedMusic.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(selectedMusic)
        }
      );

      setModalVisible(false);
      loadMusic();

      alert("Sauvegardé");
    } catch {
      alert("Erreur serveur");
    }
  };

  const removeFromCatalog = async () => {
    if (!selectedMusic || removing) return;

    const token =
      localStorage.getItem("evoAccessToken");

    if (!token) {
      setRemoveError(
        "Session admin expirée. Reconnecte-toi."
      );
      return;
    }

    setRemoving(true);
    setRemoveError("");

    try {
      const res = await fetch(
        `${API}/music/catalog/${selectedMusic.id}`,
        {
          method: "DELETE",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await res
        .json()
        .catch(() => ({}));

      if (!res.ok) {
        throw new Error(
          data?.error ||
          "Impossible de retirer cette musique."
        );
      }

      if (
        current &&
        Number(current.id) ===
          Number(selectedMusic.id)
      ) {
        if (audioRef.current) {
          audioRef.current.pause();
          audioRef.current = null;
        }

        setCurrent(null);
        setPlaying(false);
        setPosition(0);
        setDuration(0);
      }

      setMusics((prev) =>
        prev.filter(
          (music) =>
            Number(music.id) !==
            Number(selectedMusic.id)
        )
      );

      setRemoveConfirm(false);
      setRemoveError("");
      setSelectedMusic(null);
      setModalVisible(false);
    } catch (error) {
      setRemoveError(
        error?.message ||
        "Impossible de retirer cette musique."
      );
    } finally {
      setRemoving(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#020b14",
        color: "#fff",
        paddingBottom: 180
      }}
    >
      <div
        style={{
          height: 90,
          display: "flex",
          alignItems: "center",
          background: "#031220",
          padding: "35px 15px 0"
        }}
      >
        <button
          onClick={() => {
            window.location.href = "/admin";
          }}
          style={{
            border: `1px solid ${NEON}`,
            padding: 6,
            borderRadius: 6,
            background: "transparent",
            color: NEON,
            fontSize: 10,
            cursor: "pointer"
          }}
        >
          RETOUR
        </button>

        <div
          style={{
            flex: 1,
            textAlign: "center",
            fontWeight: "bold",
            fontSize: 14
          }}
        >
          ADMIN MUSIQUE
        </div>

        <div style={{ width: 70 }} />
      </div>

      {loading ? (
        <div
          style={{
            padding: 50,
            textAlign: "center",
            color: NEON
          }}
        >
          Chargement...
        </div>
      ) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fit,minmax(220px,1fr))",
            gap: 14,
            padding: 15
          }}
        >
          {musics.map((m) => (
            <div
              key={m.id}
              style={{
                background: "#051626",
                borderRadius: 8,
                padding: 8,
                border: "1px solid #1a2b3c"
              }}
            >
              <img
                src={musicCoverUrl(m.cover_path)}
                alt=""
                onClick={() => playMusic(m)}
                style={{
                  width: "100%",
                  height: 140,
                  objectFit: "cover",
                  borderRadius: 6,
                  cursor: "pointer"
                }}
              />

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: 8
                }}
              >
                <div style={{ flex: 1 }}>
                  <div
                    style={{
                      color: NEON,
                      fontSize: 12,
                      fontWeight: "bold"
                    }}
                  >
                    {m.title}
                  </div>

                  <div
                    style={{
                      color: "#fff",
                      fontSize: 11
                    }}
                  >
                    {m.artist}
                  </div>
                </div>

                <button
                  onClick={() => {
                    setSelectedMusic(m);
                    setRemoveConfirm(false);
                    setRemoveError("");
                    setModalVisible(true);
                  }}
                  style={{
                    background: "transparent",
                    border: "none",
                    color: NEON,
                    fontSize: 24,
                    cursor: "pointer"
                  }}
                >
                  ☰
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {current && (
        <div
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            height: 160,
            display: "flex",
            alignItems: "center",
            padding: 20,
            background: "#031220",
            borderTop: `1px solid ${NEON}`,
            zIndex: 999
          }}
        >
          <img
            src={musicCoverUrl(current.cover_path)}
            alt=""
            style={{
              width: 60,
              height: 60,
              borderRadius: 8,
              marginRight: 12
            }}
          />

          <div style={{ flex: 1 }}>
            <div
              style={{
                color: NEON,
                fontSize: 16,
                fontWeight: "bold"
              }}
            >
              {current.title}
            </div>

            <div
              style={{
                color: "#fff",
                fontSize: 13
              }}
            >
              {current.artist}
            </div>

            <input
              type="range"
              min="0"
              max={duration || 1}
              value={position}
              onChange={seek}
              style={{
                width: "100%",
                marginTop: 10
              }}
            />

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                color: "#aaa",
                fontSize: 11
              }}
            >
              <span>{format(position)}</span>
              <span>{format(duration)}</span>
            </div>
          </div>

          <button
            onClick={togglePlay}
            style={{
              background: "transparent",
              border: "none",
              color: NEON,
              fontSize: 42,
              cursor: "pointer"
            }}
          >
            {playing ? "⏸" : "▶"}
          </button>
        </div>
      )}

      {modalVisible && selectedMusic && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.9)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 20,
            zIndex: 9999
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: 600,
              maxHeight: "90vh",
              overflow: "auto",
              background: "#031220",
              borderRadius: 12,
              padding: 20,
              border: `1px solid ${NEON}`
            }}
          >
            <div
              style={{
                color: NEON,
                fontSize: 16,
                textAlign: "center",
                marginBottom: 15
              }}
            >
              MODIFIER
            </div>

            {[
              "title",
              "artist",
              "album",
              "year",
              "genre",
              "file_path",
              "cover_path"
            ].map((f) => (
              <input
                key={f}
                placeholder={f}
                value={selectedMusic[f] || ""}
                onChange={(e) =>
                  setSelectedMusic({
                    ...selectedMusic,
                    [f]: e.target.value
                  })
                }
                style={{
                  width: "100%",
                  background: "#051626",
                  color: "#fff",
                  border: "1px solid #1a2b3c",
                  borderRadius: 6,
                  padding: 12,
                  marginTop: 10
                }}
              />
            ))}

            <button
              onClick={save}
              style={{
                background: NEON,
                padding: 14,
                borderRadius: 8,
                marginTop: 20,
                width: "100%",
                border: "none",
                fontWeight: "bold",
                cursor: "pointer"
              }}
            >
              VALIDER
            </button>

            {!removeConfirm ? (
              <button
                type="button"
                disabled={removing}
                onClick={() => {
                  setRemoveConfirm(true);
                  setRemoveError("");
                }}
                style={{
                  background:
                    "rgba(255,50,80,.08)",
                  border:
                    "1px solid rgba(255,70,100,.55)",
                  color: "#ff5577",
                  padding: 13,
                  borderRadius: 8,
                  marginTop: 12,
                  width: "100%",
                  fontWeight: 900,
                  cursor: "pointer"
                }}
              >
                🗑 RETIRER DU CATALOGUE
              </button>
            ) : (
              <div
                style={{
                  marginTop: 12,
                  padding: 15,
                  borderRadius: 10,
                  background:
                    "rgba(255,45,75,.07)",
                  border:
                    "1px solid rgba(255,70,100,.35)"
                }}
              >
                <div
                  style={{
                    color: "#ff6680",
                    fontSize: 13,
                    fontWeight: 900
                  }}
                >
                  Retirer cette musique ?
                </div>

                <div
                  style={{
                    color: "#aab7c0",
                    fontSize: 11,
                    lineHeight: 1.5,
                    marginTop: 6
                  }}
                >
                  « {selectedMusic.title} » sera retirée
                  du catalogue EVO-LIVE. Le fichier et
                  l'historique seront conservés.
                </div>

                {removeError && (
                  <div
                    style={{
                      marginTop: 10,
                      color: "#ff7890",
                      fontSize: 11
                    }}
                  >
                    ⚠️ {removeError}
                  </div>
                )}

                <div
                  style={{
                    display: "flex",
                    gap: 9,
                    marginTop: 14
                  }}
                >
                  <button
                    type="button"
                    disabled={removing}
                    onClick={() => {
                      setRemoveConfirm(false);
                      setRemoveError("");
                    }}
                    style={{
                      flex: 1,
                      padding: 11,
                      borderRadius: 8,
                      background: "transparent",
                      border:
                        "1px solid rgba(0,242,255,.35)",
                      color: NEON,
                      fontWeight: 900,
                      cursor: "pointer"
                    }}
                  >
                    ANNULER
                  </button>

                  <button
                    type="button"
                    disabled={removing}
                    onClick={removeFromCatalog}
                    style={{
                      flex: 1.4,
                      padding: 11,
                      borderRadius: 8,
                      background: "#d83252",
                      border: "none",
                      color: "#fff",
                      fontWeight: 900,
                      cursor: removing
                        ? "default"
                        : "pointer",
                      opacity: removing ? 0.6 : 1
                    }}
                  >
                    {removing
                      ? "RETRAIT..."
                      : "🗑 CONFIRMER LE RETRAIT"}
                  </button>
                </div>
              </div>
            )}

            <button
              type="button"
              disabled={removing}
              onClick={() => {
                setModalVisible(false);
                setSelectedMusic(null);
                setRemoveConfirm(false);
                setRemoveError("");
              }}
              style={{
                background: "transparent",
                border: "none",
                color: "#fff",
                width: "100%",
                marginTop: 15,
                cursor: removing
                  ? "default"
                  : "pointer"
              }}
            >
              FERMER
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminMusicWebPage;
